/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-07-11
 */

export const baseUrl: any = process.env.REACT_APP_BASE_URL;

export type ReceiptType =  {
    amount: number,
    repeats: number,
    repeatsReceived: number,
    repeatsSuccess: number,
    paidInd: boolean,
    currencyCode: string,
    isDonation: boolean,
    isLeaf: boolean,
    subscriberName: string,
    donorName: string,
    deceasedName: string,
    created: string
}

export const htmlCodeAssist = (code: string) => {
    const parser = new DOMParser();
    return parser.parseFromString(code, 'text/html').body.textContent;
}

export const scrollTop = () => {
    debug("", "Scrolling to the Top of the Page.");
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
}

export const debug = (category: string, message: any) => {
    const enabled: any = process.env.REACT_APP_DEBUG;
    if(enabled) {
        if(category) {
            console.log(category + " : " + message);
        } else {
            console.log(message);
        }
    }
}

export const formatDateFull = (dateString: string): string => {
    const theDate = new Date(dateString);
    return theDate.toLocaleDateString().replaceAll("\/", "-") + " " + theDate.toLocaleTimeString();
}

export const formatDateShort = (dateString: string): string => {
    const theDate = new Date(dateString);
    return theDate.toLocaleDateString().replaceAll("\/", "-");
}

export const fetchImageStatus = async (endpoint: string) => {
    const fullUrl = baseUrl + "/" + endpoint;
    const response = await fetch(fullUrl);
    return(response);
}

// Use this function to retrieve data from the server.
export const fetchRecords = async (endpoint: string, processData: any) => {

    const fullUrl = baseUrl + "/" + endpoint;
    debug("fetchRecords", "Configured to use " + fullUrl);
    
    const response = await fetch(fullUrl);
    if(!response.ok) {
        throw new Error("Invalid Response Status : " + response.status + " - " + response.statusText);
    }

    const responseJson = await response.json();
    return processData(responseJson);
}

export const deleteRecord = async (endpoint: string, callbackSuccess?: any, callbackError?: any) => {

    const fullUrl = baseUrl + "/" + endpoint;
    debug("deleteRecord", "Configured to use " + fullUrl);

    try {
        const fullUrl = baseUrl + "/" + endpoint;
        
        debug("postFormData", "Configured to use " + fullUrl);

        fetch(fullUrl, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer <token>'
            }
        })
        .then((response) => response.json())
        .then((responseJson) => {
            debug("postFormData", "Response : " + JSON.stringify(responseJson))
            callbackSuccess(responseJson);
        })
        .catch((response) => callbackError(response))
        
    } catch (error) {
        callbackError(error);
        debug("postFormData", "Error - " + error);
    }        

}

// Use this function to post fromData from the modals.
export const postFormData = async (endpoint: string, formData: any, callbackSuccess?: any, callbackError?: any) => {

    try {
        const fullUrl = baseUrl + "/" + endpoint;
        
        debug("postFormData", "Configured to use " + fullUrl);
        debug("postFormData", "Payload - " + JSON.stringify(formData));

        fetch(fullUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer <token>'
            },
            body: JSON.stringify(formData)
        })
        .then((response) => response.json())
        .then((responseJson) => {
            debug("postFormData", "Response : " + JSON.stringify(responseJson))
            callbackSuccess(responseJson);
        })
        .catch((response) => callbackError(response))
        
    } catch (error) {
        callbackError(error);
        debug("postFormData", "Error - " + error);
    }
}

// Use this function to post multipart fromData.
export const postFormMultiPartFormData = async (endpoint: string, formData: FormData, callbackSuccess?: any, callbackError?: any) => {

    try {
        const fullUrl = baseUrl + "/" + endpoint;
        
        debug("postFormData", "Configured to use " + fullUrl);
        debug("postFormData", "Payload - " + formData);

        fetch(fullUrl, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer <token>'
            },
            body: formData
        })
        .then((response) => {
            if(response.ok) {
                callbackSuccess(response);
            } else {
                callbackError(response);
            }
            debug("postFormData", "Response : " + JSON.stringify(response))
        }) 
        .catch((response) => callbackError(response))
        
    } catch (error) {
        callbackError(error);
        debug("postFormData", "Error - " + error);
    }
}

export const validateEmail = (email: string): boolean => {
    return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
}

export const formatCurrency = (currencyNumber: number): any => {
    return currencyNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}